<div class="page-container rb-grid-container">
  @if (gridConfig.breadcrumb) {
    <app-breadcrumb [crumbConfig]="gridConfig.breadcrumb" />
  }
  @if (gridConfig.title) {
    <h1 class="header col-12 mb-2">
      {{ gridConfig.title }}
      <span class="header-button-container">
        <ng-content select=".header-button" />
        @if (gridConfig.downloadGridButton) {
          <app-download-grid-report
            [fileLoading]="fileLoading"
            [gridData]="gridData"
            [getData]="getDownloadData"
            [generateQueryData]="getDownloadQuery"
            [gridConfig]="gridConfig"
            [hidden]="hidden"
            [reportFilters]="reportFilters"
            [selectedRecords]="selectedTradeList"
            [bulkSelect]="bulkSelectControl"
            (toggleLoading)="toggleFileLoading($event)"
          />
        }

        @if (gridConfig.autoReports) {
          <button
            type="button"
            class="ms-2"
            mat-raised-button
            color="primary"
            (click)="launchToAutoReports($event)"
          >
            Go to Automated Reports
          </button>
        }
      </span>
    </h1>
  }
  @if (!hideGrid && gridData.data) {
    @if (gridConfig.showGridFilters) {
      <div
        class="row mb-0"
        [ngClass]="{
          'case-search-filters': gridConfig.gridName === 'CaseSearch',
        }"
      >
        <app-grid-filters
          class="col-12"
          [defaultEmptyGrid]="gridConfig.defaultEmptyGrid"
          [gridName]="gridConfig.gridName"
          [filters]="externalFilters"
          [preexistingFilters]="filter"
          [defaultViewSet]="defaultViewSet"
          [reset]="resetFilters"
          [showFilterManager]="gridConfig.showFilterManager"
          [manualSearch]="gridConfig.manualSearch"
          [searchButtonText]="gridConfig.searchButtonText"
          [showBridgeIdSearch]="gridConfig.showBridgeIdSearch"
          [disableSearch]="disableSearch()"
          [selectedTemplateVar]="gridConfig.preselectedFilters"
          [colFiltersChanged]="colFiltersChanged"
          [hiddenCols]="hidden"
          [colSort]="state.sort"
          [colOrder]="gridOrderFields"
          (filtersUpdated)="updateFilters($event)"
          (triggerSearch)="triggerGridSearch()"
          (bridgeIdSearch)="setBridgeIdSearch($event)"
          (additionalData)="handleAdditionalData($event)"
          (hiddenColsEmitter)="emitHiddenCols($event)"
          (colSortEmitter)="emitColSort($event)"
          (colOrderEmitter)="emitGridOrder($event)"
        />
      </div>
    }
    @if (
      gridConfig.gridName === 'IWProductShelf' &&
      !gridConfig.disableProgramFilter
    ) {
      <div class="col-12 mb-2 mx-1 filter-modal-result">
        <p>
          <strong>Showing Products from Program: </strong>
          {{ gridConfig.initialProgram }}
        </p>
        @if (!singleProgram) {
          <button type="button" mat-button (click)="gridConfig.changeProgram()">
            <mat-icon>search</mat-icon>Change Program Name Filter
          </button>
        }
      </div>
    }

    @if (
      !gridConfig.defaultEmptyGrid ||
      (gridConfig.defaultEmptyGrid && !showEmptyGridWarning && !simpleLoading)
    ) {
      <div class="w-100 d-flex mb-0 mx-0 grid-controls">
        <ng-content selector=".custom-grid-control" />

        @if (gridConfig.showBulkActions) {
          <app-bulk-actions
            [gridType]="gridConfig.gridType"
            [rowSelector]="gridConfig.rowSelector"
            [pagesSelected]="pagesSelected"
            [selectedTradeList]="selectedTradeList"
            [selectedChecked]="selectedChecked"
            [skip]="skip"
            [gridData]="gridData"
            [state]="state"
            [generateQueryData]="generateQueryData.bind(this)"
            (getGridData)="getGridData()"
            (toggleGridLoading)="toggleGridLoading($event)"
            (bulkSelect)="bulkSelect($event)"
            (pageSelect)="pageSelect($event)"
            (resetSelect)="resetSelect($event)"
          />
        }

        @if (gridConfig.groupByOptions) {
          <div class="flat-grouped-radio-container">
            <mat-label><strong>View Mode:</strong></mat-label>
            <mat-radio-group
              [(ngModel)]="groupBySelection"
              (change)="changeGroupBySelection()"
            >
              @for (
                opt of gridConfig.groupByOptions;
                track opt;
                let optIndex = $index
              ) {
                <mat-radio-button value="{{ opt.value }}" class="me-1">
                  {{ opt.display }}
                  {{
                    gridConfig.gridName === 'CaseExplorer' &&
                    opt.value === 'review' &&
                    (selectedSolution === 'aw' || selectedSolution === 'li')
                      ? `(Replacements)`
                      : null
                  }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        }

        @if (gridConfig.showGridColumnFilters) {
          <app-grid-column-filter
            class="ms-auto me-2"
            [omitCols]="gridConfig.omitCols"
            [columns]="gridData.headers"
            (columnsUpdated)="externalColumnsUpdated($event)"
          />
        }

        @if (gridConfig.showGridFilters) {
          <button
            type="button"
            mat-button
            color="primary"
            class="me-0"
            [ngClass]="{
              'ms-auto':
                !gridConfig.showGridColumnFilters &&
                !gridConfig.showBulkActions,
            }"
            (click)="reset()"
          >
            <mat-icon class="me-2">replay</mat-icon>
            {{ gridConfig.resetBtnText || 'Reset Grid' }}
          </button>
        }
      </div>
    }

    @if (
      (gridConfig.defaultEmptyGrid && showEmptyGridWarning) ||
      (gridConfig.gridName === 'RepBehavior' && !disableSearch())
    ) {
      <div class="row mb-0 mx-0">
        <div class="col-12 p-0">
          <p class="mb-0 grid-warning">
            @if (!disableSearch()) {
              Selected filter criteria do not reflect data shown in results
            } @else {
              Define filter criteria to generate report
            }
          </p>
        </div>
      </div>
    }

    @if (ptGrids.includes(gridConfig.gridName) && showPtDateWarning) {
      <div class="row mb-0 mx-0">
        <div class="col-12 p-0">
          <p class="mb-2 grid-warning">
            Expanding search beyond "Last 30 Days" can cause long load times.
          </p>
        </div>
      </div>
    }

    @if (
      !gridConfig.defaultEmptyGrid ||
      (gridConfig.defaultEmptyGrid && !showEmptyGridWarning && !simpleLoading)
    ) {
      @if (gridConfig.gridName === 'RepBehavior' && reportDescription) {
        <app-firm-benchmarking
          #firmBenchmarking
          [benchmarkData]="benchmarkData"
          [loading]="loadingBenchmarks"
          [label]="reportDescription.ReportName"
          [description]="reportDescription.ReportDescription"
        />
      }

      <span
        [ngClass]="{
          'search-grid-container unified': gridConfig.gridName === 'CaseSearch',
          'copy-case-grid': gridConfig.gridName === 'CopyCase',
        }"
      >
        <kendo-grid
          #rbGrid="kendoGrid"
          class="col-12"
          [data]="gridData"
          [skip]="state.skip * 1"
          [pageSize]="state.take"
          [pageable]="true"
          [sortable]="{ allowUnsort: true, mode: 'multiple' }"
          [reorderable]="gridConfig.reorderable"
          [sort]="state.sort"
          [selectable]="selectableSetting"
          [filterable]="'menu'"
          [filter]="state.filter"
          [columnMenu]="{ columnChooser: false }"
          [state]="state"
          [height]="gridHeight()"
          [rowClass]="checkRowClass"
          [navigable]="true"
          (columnReorder)="columnReorderTrigger($event, rbGrid)"
          (pageChange)="pageChangeEvent($event)"
          (selectionChange)="selectRow($event)"
          (dataStateChange)="dataStateChange($event)"
        >
          @if (gridConfig.gridActionColumn) {
            @if (gridConfig.gridName === 'CaseSearch') {
              <kendo-grid-column
                class="color-key-container"
                title="Application"
                [width]="285"
              >
                <ng-template kendoGridHeaderTemplate>
                  Launch Case in an Application <mat-icon>info</mat-icon>
                </ng-template>
                <ng-template kendoGridColumnMenuTemplate>
                  <div class="px-3 py-1">
                    <div class="color-key-item d-flex align-items-center">
                      <span class="color-key me-1"></span> = Complete
                    </div>
                    <div class="color-key-item d-flex align-items-center">
                      <span class="color-key me-1"></span> = In Progress
                    </div>
                    <div class="color-key-item d-flex align-items-center">
                      <span class="color-key me-1"></span> = Not Started
                    </div>
                  </div>
                </ng-template>
                <ng-template let-dataItem kendoGridCellTemplate>
                  <app-launch-app-buttons
                    [dataItem]="dataItem"
                    [showSummaryLink]="showSummaryLink"
                  />
                </ng-template>
              </kendo-grid-column>
            } @else if (gridConfig.gridName !== 'CopyCase') {
              <kendo-grid-column width="125" title="Actions">
                <ng-template let-dataItem kendoGridCellTemplate>
                  <div class="action-buttons-container">
                    @if (
                      gridConfig.gridName === 'CaseManagement' &&
                      dataItem['NewUpdate']
                    ) {
                      <span
                        class="update-indicator"
                        matTooltip="New Updates"
                      ></span>
                    }
                    @if (
                      gridConfig.showBulkActions || gridConfig.selectableRows
                    ) {
                      <mat-checkbox
                        [matTooltip]="gridConfig.selectActionText"
                        [checked]="
                          selectedChecked[dataItem[gridConfig.rowSelector]] ||
                          bulkSelectControl
                        "
                        [disabled]="bulkSelectControl"
                        (click)="toggleRowSelect(dataItem)"
                      />
                    }
                    @if (gridConfig.gridActions) {
                      @for (action of gridConfig.gridActions; track action) {
                        @if (
                          (action.hasOwnProperty('show') &&
                            action.show(dataItem)) ||
                          !action.hasOwnProperty('show')
                        ) {
                          <button
                            type="button"
                            mat-icon-button
                            class="fs-button"
                            [color]="action.color"
                            [matTooltip]="action.text"
                            (click)="
                              action.action
                                ? action.action($event, dataItem, this)
                                : viewRecord(dataItem)
                            "
                          >
                            <mat-icon>{{ action.icon }}</mat-icon>
                          </button>
                        }
                      }
                    } @else {
                      <button
                        type="button"
                        mat-icon-button
                        class="fs-button"
                        color="primary"
                        [matTooltip]="
                          gridConfig.showActionId
                            ? gridConfig.previewActionText +
                              ': ' +
                              dataItem[gridConfig.rowSelector]
                            : gridConfig.previewActionText
                        "
                        (click)="viewRecord(dataItem)"
                      >
                        @if (gridConfig.gridName === 'CaseManagement') {
                          <mat-icon>rate_review</mat-icon>
                        } @else {
                          <mat-icon>preview</mat-icon>
                        }
                      </button>
                    }
                    @if (gridConfig.deleteRow) {
                      <button
                        type="button"
                        mat-icon-button
                        color="warn"
                        class="fs-button"
                        [matTooltip]="gridConfig.deleteRowText"
                        (click)="deleteRow(dataItem)"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                </ng-template>
              </kendo-grid-column>
            }
          }
          @for (column of gridData.headers; track column) {
            <kendo-grid-column
              class="{{ column.AllowDecrypt ? 'button-cell-container' : '' }}"
              [field]="column.DataField"
              [hidden]="isHidden(column.DataField)"
              [title]="column.Label"
              [sortable]="column.Sort"
              [groupable]="column.Group"
              [media]="column.RespVis"
              [width]="column.hasOwnProperty('Width') ? column.Width : 150"
              [filterable]="column.Filter"
              [sticky]="column.Sticky"
            >
              @if (column.Sort || column.Filter) {
                <ng-template let-service="service" kendoGridColumnMenuTemplate>
                  @if (column.Sort) {
                    <kendo-grid-columnmenu-sort
                      [column]="column"
                      [service]="service"
                    >
                      <kendo-grid-messages
                        [sortAscending]="getFilterMenuText(column.Type, 'asc')"
                        [sortDescending]="
                          getFilterMenuText(column.Type, 'desc')
                        "
                      />
                    </kendo-grid-columnmenu-sort>
                  }
                  @if (column.Filter) {
                    <kendo-grid-columnmenu-filter
                      [column]="column"
                      [service]="service"
                    >
                      <ng-template
                        let-filter="filter"
                        let-filterService="filterService"
                        kendoGridFilterMenuTemplate
                      >
                        @switch (column.FilterType) {
                          @case ('Dropdown') {
                            <kendo-multiselect
                              style="width: 99%"
                              textField="display"
                              valueField="value"
                              placeholder="Filter By..."
                              [data]="filterData[column.DataField]"
                              [filterable]="true"
                              [valuePrimitive]="true"
                              [value]="filter | filterValues"
                              [fillMode]="'outline'"
                              (valueChange)="
                                multiselectFilterValueChange(
                                  $event,
                                  column.DataField,
                                  filterService,
                                  column,
                                  service
                                )
                              "
                              (filterChange)="
                                onFilterChange($event, column.DataField)
                              "
                            />
                          }
                          @case ('Search') {
                            <kendo-textbox
                              placeholder="Filter By..."
                              style="width: 99%"
                              [value]="getTextboxValue(column.DataField)"
                              [fillMode]="'outline'"
                              (valueChange)="
                                searchFilterValueChange(
                                  $event,
                                  column.DataField,
                                  filterService,
                                  column
                                )
                              "
                            />
                          }
                          @case ('DateRange') {
                            <app-date-range-filter
                              [field]="column.DataField"
                              [filter]="filter"
                              [filterService]="filterService"
                              (updateFilter)="
                                dateFilterValueChange($event, column.DataField)
                              "
                            />
                          }
                          @case ('ValueRange') {
                            <app-amount-range-filter
                              [field]="column.DataField"
                              [filter]="filter"
                              [filterService]="filterService"
                              (updateFilter)="
                                valueRangeFilterValueChange(
                                  $event,
                                  column.DataField
                                )
                              "
                            />
                          }
                          @case ('CommaSearch') {
                            <kendo-textbox
                              style="width: 99%"
                              placeholder="Filter By..."
                              [data]="filterData[column.DataField]"
                              [filterable]="true"
                              [value]="filter | filterValues"
                              [fillMode]="'outline'"
                              (filterChange)="
                                onFilterChange($event, column.DataField)
                              "
                              (valueChange)="
                                commaSelectFilterValueChange(
                                  $event,
                                  column.DataField,
                                  filterService,
                                  column
                                )
                              "
                            />
                          }
                        }
                      </ng-template>
                    </kendo-grid-columnmenu-filter>
                  }
                </ng-template>
              }
              @if (gridConfig.gridName === 'CaseManagement') {
                @if (column.DataField === 'StatusName') {
                  <ng-template let-dataItem kendoGridCellTemplate>
                    <div class="status-score-text-wrapper">
                      @if (dataItem.Icon) {
                        <mat-icon
                          class="icon-{{ dataItem.Color }}"
                          [ngClass]="{ 'icon-grey': !dataItem.Color }"
                        >
                          {{ dataItem.Icon }}
                        </mat-icon>
                      }
                      {{ dataItem[column.DataField] }}</div
                    >
                  </ng-template>
                }
              }
              @if (scoreIconDataFields.includes(column.DataField)) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  <div class="scoreclass-container">
                    <mat-icon class="ms-0 {{ dataItem[column.DataField] }}">
                      {{ scoreClassKey[dataItem[column.DataField]] }}
                    </mat-icon>
                  </div>
                </ng-template>
              }
              @if (
                (gridConfig.gridName === 'CaseExplorer' ||
                  gridConfig.gridName === 'RepBehavior') &&
                (column.DataField.toLowerCase() === 'user' ||
                  column.DataField.toLowerCase() === 'username' ||
                  column.DataField.toLowerCase() === 'repcode')
              ) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] }}

                  @for (action of gridConfig.gridActions; track action) {
                    @if (!(action.icon === 'history' && allSolutionDisplay)) {
                      <button
                        type="button"
                        matIconButton
                        class="pull-right"
                        [color]="action.color"
                        [matTooltip]="action.text"
                        (click)="
                          action.action
                            ? action.action($event, dataItem, this)
                            : viewRecord(dataItem)
                        "
                      >
                        <mat-icon>{{ action.icon }}</mat-icon>
                      </button>
                    }
                  }
                </ng-template>
              }
              @if (
                gridConfig.gridName === 'CopyCase' &&
                column.DataField.toLowerCase() === 'clientname'
              ) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  @if (selectedProfileId === dataItem.profileId) {
                    <mat-icon>check_circle</mat-icon>
                  }
                  {{ dataItem[column.DataField] }}
                </ng-template>
              }
              @if (column.Type === 'integer') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | number: '1.0-0' }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | number: '1.0-0' }}
                </ng-template>
              } @else if (column.Type === 'perc') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | percent }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | percent }}
                </ng-template>
              } @else if (column.Type === 'perc2') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | percent: '1.2' }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | percent: '1.2' }}
                </ng-template>
              } @else if (column.Type === 'curr') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | currency }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | currency }}
                </ng-template>
              } @else if (column.Type === 'hiddenValues') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  @if (dataItem[column.DataField].length > 1) {
                    <button
                      type="button"
                      matButton
                      color="primary"
                      (click)="viewHiddenValues(column, dataItem)"
                    >
                      Click to View
                      <span class="hidden-count">
                        ({{ dataItem[column.DataField].length }})
                      </span>
                    </button>
                  } @else if (dataItem[column.DataField].length === 1) {
                    @if (
                      column.AllowDecrypt &&
                      dataItem[column.DataField][0] &&
                      dataItem[column.DecryptTarget][0]
                    ) {
                      <app-decrypt-field
                        [label]="dataItem[column.DataField]"
                        [value]="dataItem[column.DecryptTarget][0]"
                        [title]="column.Label"
                      />
                    } @else {
                      {{ dataItem[column.DataField] }}
                    }
                  } @else {
                    <span class="no-data">No Data</span>
                  }
                </ng-template>
              } @else if (column.AllowDecrypt) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  @if (
                    dataItem[column.DataField] && dataItem[column.DecryptTarget]
                  ) {
                    <app-decrypt-field
                      [label]="dataItem[column.DataField]"
                      [value]="dataItem[column.DecryptTarget]"
                      [title]="column.Label"
                    />
                  } @else if (
                    dataItem[column.DataField] &&
                    !dataItem[column.DecryptTarget]
                  ) {
                    {{ dataItem[column.DataField] }}
                  }
                </ng-template>
              } @else if (column.DataField === 'savedTime') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | localTime: 'shortDateTime' }}
                </ng-template>
              } @else if (column.Type === 'date') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | date: 'short' }}
                </ng-template>
              } @else if (column.Type === 'shortDate') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | date: 'shortDate' }}
                </ng-template>
              } @else if (column.DataField === 'notes') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  <span [innerHtml]="dataItem[column.DataField]"></span>
                </ng-template>
              } @else if (column.DataField === 'AlertIDs') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  <app-alert-list-display
                    [dataItem]="dataItem[column.DataField]"
                    [headers]="gridData.headers"
                  />
                </ng-template>
              } @else if (column.Validation) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  <span
                    [innerHtml]="
                      displayValue(column, dataItem[column.DataField])
                    "
                  ></span>
                </ng-template>
              }
            </kendo-grid-column>
          }
          @if (
            gridConfig.gridName === 'CaseSearch' &&
            (selectiveCopyCase || copyProfile || canDelete)
          ) {
            <kendo-grid-column
              [sortable]="false"
              [groupable]="false"
              [width]="70"
              [filterable]="false"
              [title]="'Actions'"
            >
              <ng-template let-dataItem kendoGridCellTemplate>
                <button
                  type="button"
                  mat-icon-button
                  kendoGridFocusable
                  [matMenuTriggerFor]="caseSearchMenu"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #caseSearchMenu="matMenu">
                  @if (selectiveCopyCase) {
                    <app-copy-case
                      [donorCase]="dataItem"
                      [rights]="rights"
                      (toggleLoading)="toggleGridLoading($event)"
                    />
                  }
                  @if (copyProfile) {
                    <app-clone-case
                      [donorCase]="dataItem"
                      [rights]="rights"
                      (toggleLoading)="toggleGridLoading($event)"
                    />
                  }
                  @if (canDelete) {
                    <button
                      type="button"
                      mat-menu-item
                      matTooltip="Delete Profile"
                      matTooltipPosition="above"
                      [matTooltipShowDelay]="1000"
                      (click)="deleteProfile(dataItem.profileId)"
                    >
                      <mat-icon>delete</mat-icon>
                      <span>Delete Profile</span>
                    </button>
                  }
                </mat-menu>
              </ng-template>
            </kendo-grid-column>
          }
          @if (gridData?.['subHead'].length > 0) {
            <ng-template let-dataItem kendoGridDetailTemplate>
              <app-subhead-table
                [subHead]="gridData['subHead']"
                [products]="dataItem.products"
              />
            </ng-template>
          }
          <ng-template
            let-totalPages="totalPages"
            let-currentPage="currentPage"
            kendoPagerTemplate
          >
            <kendo-pager-prev-buttons />
            <kendo-pager-numeric-buttons [buttonCount]="buttonCount" />
            <kendo-pager-next-buttons />
            <kendo-pager-input />
            <kendo-pager-info />
            <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
          </ng-template>
        </kendo-grid>
      </span>
    }
  }

  @if (simpleLoading && gridConfig.simpleLoader) {
    <app-simple-loading [message]="gridConfig.simpleLoaderText" />
  }
  <ngx-loading [show]="loading" />
</div>
